import { Flex } from "@redotech/arbiter/flex";
import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import PackageIcon from "@redotech/redo-icons/package.svg";
import { isEnumValue } from "@redotech/util/enum";
import classNames from "classnames";
import { memo, useMemo, useState } from "react";
import { getCarrierLogoUrl } from "../../carrier/logo";
import * as css from "./shipping-logo.module.css";

export enum LogoSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export const ShippingLogo = memo(function ShippingLogo({
  carrier,
  size,
}: {
  carrier: Carriers | string | null;
  size: LogoSize;
}) {
  const logoUrl = useMemo(() => {
    return carrier ? getCarrierLogoUrl(carrier) : "";
  }, [carrier]);
  const [failedLogoUrl, setFailedLogoUrl] = useState<string | null>(null);

  const showBorderRadius =
    !!isEnumValue(carrier, Carriers) &&
    ![Carriers.UPS_SUREPOST, Carriers.UPS].includes(carrier);
  const showLogo = logoUrl !== "" && failedLogoUrl !== logoUrl;

  return (
    <Flex
      className={classNames(
        css.logoContainer,
        size === LogoSize.SMALL && css.small,
        size === LogoSize.LARGE && css.large,
      )}
      flexDirection="column"
      justify="center"
    >
      {showLogo && (
        <img
          alt={carrier ? `${carrier} logo` : "Shipping carrier logo"}
          className={classNames(
            css.nameLogo,
            size === LogoSize.SMALL && css.small,
            size === LogoSize.LARGE && css.large,
            showBorderRadius && css.borderRadius,
          )}
          onError={() => setFailedLogoUrl(logoUrl)}
          src={logoUrl}
        />
      )}
      {!showLogo && (
        <PackageIcon
          className={classNames(
            css.nameLogo,
            size === LogoSize.SMALL && css.small,
            size === LogoSize.LARGE && css.large,
            showBorderRadius && css.borderRadius,
          )}
          height={24}
          width={24}
        />
      )}
    </Flex>
  );
});
